import PageHero from "../components/PageHero";
import Seo from "../components/Seo";
import ImpactGallery from "../components/sections/ImpactGallery";
import { VolunteerCta, SpecialCta } from "../components/sections/CtaSections";

export default function Impact() {
  return (
    <main>
      <Seo
        title="हमारा जमीनी प्रभाव — समुदाय के साथ वास्तविक काम"
        description="Anansha Welfare Society का जमीनी प्रभाव — समुदाय के बीच पहुंच, शिक्षा, स्वास्थ्य और जागरूकता की वास्तविक गतिविधियों की तस्वीरें, वाराणसी।"
        path="/impact"
        breadcrumb={["प्रभाव"]}
      />
      <PageHero
        overline={{ hi: "प्रभाव", en: "Impact" }}
        title={{ hi: "हमारा जमीनी प्रभाव", en: "Our Grassroots Impact" }}
        description={{
          hi: "हम संख्याओं से ज्यादा वास्तविक बदलाव पर विश्वास रखते हैं — समुदाय के बीच पहुंच, संवाद और सहायता।",
          en: "We believe in real change more than numbers — outreach, dialogue and support within communities.",
        }}
        testid="impact-page-heading"
      />
      <ImpactGallery limit={0} showMore={false} />
      <VolunteerCta />
      <SpecialCta />
    </main>
  );
}
